/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Barge_TitleInputs */



/**
* | output |
* | --- |
* | "Barge inspections (BIRE and EBIS)" |
*
* @param {Service_Barge_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_barge_title = /** @type {((inputs?: Service_Barge_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Barge_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("驳船检查（BIRE 和 EBIS）")
	return /** @type {LocalizedString} */ ("Barge inspections (BIRE and EBIS)")
});